import React from "react";
import {
  Card,
  Button,
  TextButton,
  MarketingLayout,
  FormField,
  Input,
  Image,
  Layout,
  Box,
  Cell,
  SectionHelper,
  Text,
  Loader,
  Notification,
  Dropdown,
  ToggleSwitch,
  Checkbox,
  Collapse,
  Modal,
  CustomModalLayout,
  Divider,
  Badge
} from '@wix/design-system';

import { passCsrfToken } from '../../util/helpers'
import axios from 'axios'

class MyAccount extends React.Component {

  state = {
    config: this.props.configData,
    selectedSameAddress: this.props.configData.same_address_return_sender,
    // Mode d'authentification. La clé API est le mode par défaut ; le couple
    // identifiant / mot de passe est un mode alternatif que Colissimo va
    // désactiver. Ce flag n'est PAS persisté (pas de colonne en base) : il est
    // redéduit à chaque chargement de l'état des champs, comme sur Shopify V2.
    // Un marchand déjà configuré en identifiant / mot de passe (et sans clé)
    // retrouve donc son mode ; toute autre situation ouvre sur la clé API.
    useLoginPassword: !!(
      this.props.configData.account_login && `${this.props.configData.account_login}`.length > 0 &&
      this.props.configData.account_password && `${this.props.configData.account_password}`.length > 0 &&
      !(this.props.configData.api_key && `${this.props.configData.api_key}`.length > 0)
    ),
    showApiKeyHelp: false,
    loading: false,
    testWebservice: false,
    showNotification: false,
    loadingSaveProcess: false,
    // Diagnostic des web services Colissimo (encart sous le bouton de test).
    // `diagnostic` reste null tant que le marchand ne l'a pas lance : l'encart
    // n'affiche alors que son descriptif et le bouton.
    diagnostic: null,
    diagnosticLoading: false,
    diagnosticError: false,
  };

  componentDidMount = () => {
    passCsrfToken(document, axios);
  }

  /* Methode de vérification des champs de form */
  validateForm = () => {
    var hasErrors = false;

    // Seuls les champs du mode d'authentification actif sont exigés.
    if (this.state.useLoginPassword) {
      if (this.state.config.account_login !== null && this.state.config.account_login.length < 1) {
        hasErrors = true;
      }

      if (this.state.config.account_password !== null && this.state.config.account_password.length < 1) {
        hasErrors = true;
      }
    } else {
      if (this.state.config.api_key !== null && this.state.config.api_key !== undefined && `${this.state.config.api_key}`.length < 1) {
        hasErrors = true;
      }
    }

    if (this.state.config.sender_company !== null && this.state.config.sender_company.length < 1) {
      hasErrors = true;
    }

    if (this.state.config.sender_lastname !== null && this.state.config.sender_lastname.length < 1) {
      hasErrors = true;
    }

    if (this.state.config.sender_firstname !== null && this.state.config.sender_firstname.length < 1) {
      hasErrors = true;
    }

    if (this.state.config.sender_address1 !== null && this.state.config.sender_address1.length < 1) {
      hasErrors = true;
    }

    if (this.state.config.sender_city !== null && this.state.config.sender_city.length < 1) {
      hasErrors = true;
    }

    if (this.state.config.sender_postcode !== null && this.state.config.sender_postcode.length < 1) {
      hasErrors = true;
    }

    if (this.state.config.sender_email !== null && this.state.config.sender_email.length < 1) {
      hasErrors = true;
    }

    if (this.state.config.sender_phone !== null && this.state.config.sender_phone.length < 1) {
      hasErrors = true;
    }

    if (!this.state.selectedSameAddress) {
      if (this.state.config.return_company !== null && this.state.config.return_company.length < 1) {
        hasErrors = true;
      }

      if (this.state.config.return_lastname !== null && this.state.config.return_lastname.length < 1) {
        hasErrors = true;
      }

      if (this.state.config.return_firstname !== null && this.state.config.return_firstname.length < 1) {
        hasErrors = true;
      }

      if (this.state.config.return_address1 !== null && this.state.config.return_address1.length < 1) {
        hasErrors = true;
      }

      if (this.state.config.return_city !== null && this.state.config.return_city.length < 1) {
        hasErrors = true;
      }

      if (this.state.config.return_postcode !== null && this.state.config.return_postcode.length < 1) {
        hasErrors = true;
      }

      if (this.state.config.return_email !== null && this.state.config.return_email.length < 1) {
        hasErrors = true;
      }

      if (this.state.config.return_phone !== null && this.state.config.return_phone.length < 1) {
        hasErrors = true;
      }
    }
    return !hasErrors;
  };

  validateEmail = () => {
    return new RegExp(/[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,15}/g).test(this.state.config.sender_email);
  };

  validatePhone = () => {
    return new RegExp(/(?:(?:\+|00)33|0)\s*[1-9](?:[\s.-]*\d{2}){4}/g).test(this.state.config.sender_phone);
  };

  validateReturnEmail = () => {
    return new RegExp(/[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,15}/g).test(this.state.config.return_email);
  };

  validateReturnPhone = () => {
    return new RegExp(/(?:(?:\+|00)33|0)\s*[1-9](?:[\s.-]*\d{2}){4}/g).test(this.state.config.return_phone);
  };
  /* Fin méthode de vérificiation */


  /* Pour le changement de chaque champ de formulaire */
  handleChange = (e) => {
    this.props.handleUpdateConfig(true);
    this.setState({showNotification: false});
    this.setState({
      config: { ...this.state.config, [e.target.name]: e.target.value },
    })
  };

  /* Champs sensibles collés depuis la Colissimo Box : un espace résiduel en
     début / fin fait échouer l'authentification sans message exploitable.
     On nettoie donc à la saisie. */
  handleChangeTrimmed = (e) => {
    this.props.handleUpdateConfig(true);
    this.setState({showNotification: false});
    this.setState({
      config: { ...this.state.config, [e.target.name]: `${e.target.value}`.trim() },
    })
  };

  /* Bascule vers le mode alternatif identifiant / mot de passe */
  handleToggleLoginPassword = () => {
    this.props.handleUpdateConfig(true);
    var checked = !this.state.useLoginPassword;
    if (!checked) {
      // Retour à la clé API : on vide les identifiants pour ne pas laisser en
      // base un couple inutilisé qui reprendrait la main au prochain
      // chargement (le mode est déduit des champs renseignés).
      this.setState({
        useLoginPassword: false,
        showNotification: false,
        config: { ...this.state.config, account_login: '', account_password: '' },
      })
    } else {
      // Passage à l'identifiant / mot de passe : on vide la clé API, sinon
      // elle resterait en base et le back continuerait de s'authentifier avec
      // elle (mode clé API prioritaire) alors que l'écran affiche l'inverse.
      // Le code tiers, lui, vaut pour les deux modes et n'est pas touché.
      this.setState({
        useLoginPassword: true,
        showNotification: false,
        config: { ...this.state.config, api_key: '' },
      })
    }
  };

  /* Gestion des mises à jour de country */
  handleSelectChangeCountry = (e) => {
    this.props.handleUpdateConfig(true);
    this.setState({showNotification: false});
    this.setState({
      config: { ...this.state.config, ['sender_iso_country']: e.id },
    })
  }

  handleSelectChangeReturnCountry = (e) => {
    this.props.handleUpdateConfig(true);
    this.setState({showNotification: false});
    this.setState({
      config: { ...this.state.config, ['return_iso_country']: e.id },
    })
  }
  /* Fin gestion des country */

  /* Requête de test API */
  apiTesting = () => {
    this.setState({loading: true});
    // En mode clé API, l'endpoint étiquette SOAP n'accepte pas la clé :
    // on valide via l'endpoint d'authentification (token) qui envoie bien la clé API.
    var apiKeyMode = !this.state.useLoginPassword;
    axios({
    url: apiKeyMode ? '/apitest-authentication' : '/apitest',
      method: 'POST',
      // On n'envoie QUE les credentials du mode actif, et une chaîne vide pour
      // ceux de l'autre mode. Sans ça, une clé API encore présente en base
      // faisait basculer le back en mode clé API et le test d'un couple
      // identifiant / mot de passe échouait alors qu'il était valide.
      data: {
        account_login: apiKeyMode ? '' : (this.state.config.account_login || ''),
        account_password: apiKeyMode ? '' : (this.state.config.account_password || ''),
        api_key: apiKeyMode ? (this.state.config.api_key || '') : '',
        code_tiers: this.state.config.code_tiers || '',
        instance_id: this.props.shop.instance_id
      },
    })
    .then(result => {
      if (result.data.success == true) {
        this.setState({loading: false});
        this.setState({testWebservice: 'success'});
        this.setState({showNotification: true});
      } else {
        this.setState({testWebservice: 'error'});
        this.setState({showNotification: true});
        this.setState({loading: false});
      }
    })
    .catch(error => {
      console.log(error);
      this.setState({testWebservice: 'error'});
      this.setState({showNotification: true});
      this.setState({loading: false});
    });
  };

  /* Diagnostic des web services Colissimo
     Contrairement au test de connexion ci-dessus, qui valide les identifiants
     SAISIS dans le formulaire, le diagnostic interroge les WS avec les
     identifiants ENREGISTRES : il reflete ce que l'app utilise reellement.
     D'ou le rappel d'enregistrer ses modifications avant de le lancer. */
  runDiagnostic = () => {
    this.setState({ diagnosticLoading: true, diagnosticError: false, diagnostic: null });
    axios({
      url: '/apitest-colissimo-services',
      method: 'POST',
      data: { instance_id: this.props.shop.instance_id },
    })
    .then(result => {
      // Le back renvoie toujours `results` ; une reponse sans ce champ est
      // anormale et doit tomber dans la banniere d'erreur, pas dans un encart
      // vide qui laisserait croire que tout va bien.
      if (result.data && result.data.results) {
        this.setState({ diagnostic: result.data.results, diagnosticLoading: false });
      } else {
        this.setState({ diagnosticError: true, diagnosticLoading: false });
      }
    })
    .catch(error => {
      console.log(error);
      this.setState({ diagnosticError: true, diagnosticLoading: false });
    });
  };

  /* Rendu d'une ligne de diagnostic : libelle + badge + aide + detail d'erreur */
  renderDiagnosticRow = (key) => {
    const result = this.state.diagnostic ? this.state.diagnostic[key] : null;
    if (!result) { return null; }

    return (
      <Box
        key={key}
        direction="vertical"
        gap="SP1"
        padding="SP3"
        backgroundColor="D70"
        borderRadius="6px"
        marginBottom="SP2"
      >
        <Box align="space-between" verticalAlign="middle" gap="SP2">
          <Text size="small" weight="bold">
            {I18n.t(`configs.my_account.diagnostic.${key}_label`)}
          </Text>
          <Badge skin={result.ok ? 'success' : 'danger'} size="tiny">
            {result.ok
              ? I18n.t('configs.my_account.diagnostic.ok')
              : I18n.t('configs.my_account.diagnostic.ko')}
          </Badge>
        </Box>
        <Text size="tiny" secondary>
          {I18n.t(`configs.my_account.diagnostic.${key}_help`)}
        </Text>
        {result.detail &&
          <Text size="tiny" skin={result.ok ? 'standard' : 'error'}>
            {result.detail}
          </Text>
        }
      </Box>
    );
  };

  /* Submit FORM */
  handleSubmit = () => {
    this.setState({showNotification: false});
    this.setState({ loadingSaveProcess: true });
    // Check if data is valid
    if (!this.validateForm()) {
      //return if not valid
      this.props.toggleToast(I18n.t('configs.my_account_error'), true);
      this.setState({ loadingSaveProcess: false });
      return;
    }

    if (!this.validateEmail()) {
      this.props.toggleToast(I18n.t('configs.my_account_error_email'), true);
      this.setState({ loadingSaveProcess: false });
      return;
    }

    if (!this.validatePhone()) {
      this.props.toggleToast(I18n.t('configs.my_account_error_phone'), true);
      this.setState({ loadingSaveProcess: false });
      return;
    }

    if (!this.state.selectedSameAddress) {
      if (!this.validateReturnEmail()) {
        this.props.toggleToast(I18n.t('configs.my_account_error_email'), true);
        this.setState({ loadingSaveProcess: false });
        return;
      }

      if (!this.validateReturnPhone()) {
        this.props.toggleToast(I18n.t('configs.my_account_error_phone'), true);
        this.setState({ loadingSaveProcess: false });
        return;
      }
    }

    axios({
    url: this.state.config.id ? '/configs/' + this.state.config.id : '/configs',
    method: this.state.config.id ? 'patch' : 'post',
    data: {
      config: this.state.config,
      instance_id: this.props.shop.instance_id
    },
    }).then(result => {
      if (result.data.success == true) {
        var data = result.data;
        data.config.local_offer = Object.keys(JSON.parse(data.config.local_offer));
        this.setState({ config: data.config });
        this.props.childChange(data.config);
        this.setState({loadingSaveProcess: false});
        //We update general props
        this.props.handleUpdateConfig(false);
        this.props.toggleToast(I18n.t('configs.save_success'), false);
      } else {
        this.setState({loadingSaveProcess: false});
        this.props.toggleToast(I18n.t('configs.save_error'), true);
      }
    }).catch(error => {
      console.log(error);
      this.setState({loadingSaveProcess: false});
      this.props.toggleToast(I18n.t('configs.save_error'), true);
    });
  };

  render() {
    const {
      config,
      loading,
      selectedSameAddress,
      useLoginPassword,
      showApiKeyHelp,
      showNotification,
      testWebservice,
      loadingSaveProcess,
      diagnostic,
      diagnosticLoading,
      diagnosticError
    } = this.state;

    const apiKeyFilled = config.api_key !== null && config.api_key !== undefined && `${config.api_key}`.length > 0;
    const loginFilled = config.account_login !== null && config.account_login !== undefined && `${config.account_login}`.length > 0;
    const passwordFilled = config.account_password !== null && config.account_password !== undefined && `${config.account_password}`.length > 0;

    /* Étapes de génération de la clé API dans la Colissimo Box */
    const apiKeySteps = [
      { n: 1, key: 'api_key_help_step1', img: 'https://cdn.prod.website-files.com/64a7e3393036f38e45a4c0cc/6a3cf0e9a976559ccd726f36_API%20COLISSIMO%20STEP%201.png' },
      { n: 2, key: 'api_key_help_step2', img: 'https://cdn.prod.website-files.com/64a7e3393036f38e45a4c0cc/6a3cf0e90604809bf455fd2b_API%20COLISSIMO%20STEP%202.png' },
      { n: 3, key: 'api_key_help_step3', img: 'https://cdn.prod.website-files.com/64a7e3393036f38e45a4c0cc/6a3cf0e9f4ee13ea04836416_API%20COLISSIMO%20STEP%203.png' },
      { n: 4, key: 'api_key_help_step4', img: 'https://cdn.prod.website-files.com/64a7e3393036f38e45a4c0cc/6a3cf0e9f4ee13ea048363f6_API%20COLISSIMO%20STEP%204.png' },
    ];

    const descriptionSection = (
      <Card>
        <MarketingLayout
          title={I18n.t('menu.settings')}
          description={`${I18n.t('configs.view_video')} ${I18n.t('configs.step1_video')}`}
          actions={<TextButton as="a" href="https://www.loom.com/share/734323161cf74190b0aecca1340cf1ef?sid=884da7b8-0f61-4cf6-9613-de71fa266910" target="_blank">{I18n.t('configs.view_video_button')}</TextButton>}
          size="tiny"
          image={
            <Box width="100%">
              <Image src="https://cdn.prod.website-files.com/64a7e3393036f38e45a4c0cc/69a9970f89c43a367c817966_video_ecran_113.svg" width="70%" height="70%" transparent />
            </Box>
          }
        />
      </Card>
    );

    return (
      <div>
        <Modal
          screen="desktop"
          isOpen={loadingSaveProcess}
        >
          <Loader size="large" />
        </Modal>
        {/* AIDE — GÉNÉRATION DE LA CLÉ API DANS LA COLISSIMO BOX */}
        <Modal
          screen="desktop"
          isOpen={showApiKeyHelp}
          onRequestClose={() => this.setState({ showApiKeyHelp: false })}
          shouldCloseOnOverlayClick
        >
          <CustomModalLayout
            title={I18n.t('configs.my_account.api_key_help_title')}
            primaryButtonText={I18n.t('configs.my_account.close')}
            primaryButtonOnClick={() => this.setState({ showApiKeyHelp: false })}
            onCloseButtonClick={() => this.setState({ showApiKeyHelp: false })}
            content={
              <Box direction="vertical" gap="SP4">
                <Text>{I18n.t('configs.my_account.api_key_help_intro')}</Text>
                {apiKeySteps.map((step) => (
                  <Box key={step.n} direction="vertical" gap="SP2" marginTop="SP4">
                    <Box verticalAlign="middle" gap="SP2">
                      <div
                        style={{
                          flexShrink: 0,
                          width: 24,
                          height: 24,
                          borderRadius: '50%',
                          background: '#0a3d62',
                          color: '#fff',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          fontSize: 13,
                          fontWeight: 700,
                        }}
                      >
                        {step.n}
                      </div>
                      <Text>{I18n.t(`configs.my_account.${step.key}`)}</Text>
                    </Box>
                    <img
                      src={step.img}
                      alt={I18n.t(`configs.my_account.${step.key}`)}
                      style={{ width: '100%', height: 'auto', borderRadius: 8, border: '1px solid #e1e3e5' }}
                    />
                  </Box>
                ))}
              </Box>
            }
          ></CustomModalLayout>
        </Modal>
        {/* FOMRULAIRE CONNEXION */}
        <Layout cols={12}>
          <Cell span={4}>
            {descriptionSection}
          </Cell>
          <Cell span={8}>
            <Card>
              <Card.Content>
                {/* MODE PRINCIPAL — CLÉ API */}
                <FormField
                  label={I18n.t('configs.my_account.api_key')}
                  labelPlacement="top"
                  required={!useLoginPassword}
                  suffix={
                    <TextButton size="tiny" onClick={() => this.setState({ showApiKeyHelp: true })}>
                      {I18n.t('configs.my_account.api_key_help_link')}
                    </TextButton>
                  }
                >
                  <Input
                    type="text"
                    name="api_key"
                    autocomplete="off"
                    tooltipPlacement="top-end"
                    value={config.api_key || ''}
                    onChange={this.handleChangeTrimmed}
                    status={apiKeyFilled || useLoginPassword ? '' : 'error'}
                    statusMessage={apiKeyFilled || useLoginPassword ? '' : I18n.t('configs.my_account.api_key_required')}
                  />
                </FormField>
                <br/>
                {/* Le code tiers s'applique aux DEUX modes : un marchand
                    qui expédie sous le contrat d'un logisticien en a un, qu'il
                    s'authentifie par clé API ou par identifiant. */}
                <FormField
                  label={I18n.t('configs.my_account.code_tiers')}
                  infoContent={I18n.t('configs.my_account.code_tiers_help')}
                >
                  <Input
                    type="text"
                    name="code_tiers"
                    tooltipPlacement="top-end"
                    value={config.code_tiers || ''}
                    onChange={this.handleChangeTrimmed}
                  />
                  <Text size="tiny">{I18n.t('configs.my_account.advanced_user_help')}</Text>
                </FormField>
                <br/>
                {/* MODE ALTERNATIF — IDENTIFIANT / MOT DE PASSE */}
                <Checkbox
                  size="small"
                  checked={useLoginPassword}
                  onChange={this.handleToggleLoginPassword}
                >
                  {I18n.t('configs.my_account.use_login_password')}
                </Checkbox>
                <br/>
                <Collapse open={useLoginPassword}>
                  <SectionHelper fullWidth appearance="warning">
                    <Text size="small">{I18n.t('configs.my_account.login_password_warning')}</Text>
                  </SectionHelper>
                  <br/>
                  <FormField
                    label={I18n.t('configs.my_account.account_login')}
                    infoContent={I18n.t('configs.my_account.account_login_help')}
                    required
                  >
                    <Input
                      type="number"
                      status={loginFilled || !useLoginPassword ? '' : 'error'}
                      name="account_login"
                      statusMessage={loginFilled || !useLoginPassword ? '' : I18n.t('configs.my_account.account_login_error')}
                      tooltipPlacement="top-end"
                      value={config.account_login}
                      onChange={this.handleChange}
                    />
                  </FormField>
                  <br/>
                  <FormField
                    label={I18n.t('configs.my_account.account_password')}
                    infoContent={I18n.t('configs.my_account.account_password_help')}
                    required
                  >
                    <Input
                      value={config.account_password}
                      type="password"
                      name="account_password"
                      tooltipPlacement="top-end"
                      status={passwordFilled || !useLoginPassword ? '' : 'error'}
                      statusMessage={passwordFilled || !useLoginPassword ? '' : I18n.t('configs.my_account.account_password_error')}
                      onChange={this.handleChange}
                    />
                  </FormField>
                  <br/>
                </Collapse>
                {/* Marge portée par le bouton et non par le Collapse : l'écart
                    reste le même que le bloc identifiant / mot de passe soit
                    déplié ou replié. */}
                <Box marginTop="SP4">
                  <Button size="small" with="200px" as="button" onClick={() => {this.apiTesting()}}>
                    {loading == true &&
                      <Loader size="tiny" />
                    }
                    {loading == false &&
                      I18n.t('configs.my_account.test_api')
                    }
                  </Button>
                </Box>
                <br/><br/>
                  {testWebservice == 'success' &&
                    <div>
                      <Notification autoHideTimeout="2500" theme="success" show={showNotification}>
                        <Notification.TextLabel>{I18n.t('configs.my_account.test_api_success')}</Notification.TextLabel>
                        <Notification.CloseButton />
                      </Notification><br/>
                    </div>
                  }
                  {testWebservice == 'error' &&
                    <div>
                      <Notification autoHideTimeout="2500" theme="error" show={showNotification}>
                        <Notification.TextLabel>{useLoginPassword ? I18n.t('configs.my_account.test_api_error') : I18n.t('configs.my_account.test_api_error_api_key')}</Notification.TextLabel>
                        <Notification.CloseButton />
                      </Notification><br/>
                    </div>
                  }
                  {testWebservice == 'error' &&
                    <SectionHelper fullWidth appearance="standard" title={I18n.t('configs.my_account.webservice_activation')}>
                      <Text listStyle="circle">
                        <ul>
                          <li>{useLoginPassword ? I18n.t('configs.my_account.error_connection_step1') : I18n.t('configs.my_account.error_connection_api_key_step1')} <a href="https://www.colissimo.entreprise.laposte.fr/" target='_blank'>{I18n.t('configs.my_account.colissimo_box')}</a></li>
                          <li>{I18n.t('configs.my_account.error_connection_step2')}</li>
                          <li>{I18n.t('configs.my_account.error_connection_step3')}</li>
                        </ul>
                      </Text>
                    </SectionHelper>
                  }

                  {/* ENCART — DIAGNOSTIC DES WEB SERVICES COLISSIMO
                      Le bouton de test ci-dessus repond par oui/non global.
                      Cet encart dit lequel des WS repond avec le contrat du
                      marchand : un contrat sans option Point Relais genere des
                      etiquettes mais n'affiche pas la carte au checkout, et
                      sans ce detail le marchand ne le decouvre qu'en usage
                      reel. */}
                  <Divider />
                  <Box direction="vertical" gap="SP2" marginTop="SP4">
                    <Text size="medium" weight="bold">
                      {I18n.t('configs.my_account.diagnostic.title')}
                    </Text>
                    <Text size="small" secondary>
                      {I18n.t('configs.my_account.diagnostic.description')}
                    </Text>
                    <Text size="tiny" secondary>
                      {I18n.t('configs.my_account.diagnostic.hint')}
                    </Text>

                    <Box marginTop="SP2">
                      <Button
                        size="small"
                        priority="secondary"
                        as="button"
                        disabled={diagnosticLoading}
                        onClick={() => {this.runDiagnostic()}}
                      >
                        {diagnosticLoading
                          ? <Loader size="tiny" />
                          : I18n.t(diagnostic
                              ? 'configs.my_account.diagnostic.rerun'
                              : 'configs.my_account.diagnostic.run')
                        }
                      </Button>
                    </Box>

                    {diagnosticError &&
                      <Box marginTop="SP2">
                        <SectionHelper fullWidth appearance="danger">
                          <Text size="small">{I18n.t('configs.my_account.diagnostic.error')}</Text>
                        </SectionHelper>
                      </Box>
                    }

                    {diagnostic &&
                      <Box direction="vertical" marginTop="SP3">
                        {this.renderDiagnosticRow('generate_label')}
                        {this.renderDiagnosticRow('pickup_ws')}
                        {this.renderDiagnosticRow('widget')}
                        {this.renderDiagnosticRow('cotation')}

                        {/* Synthese : on alerte des qu'un seul service est KO. */}
                        <SectionHelper
                          fullWidth
                          appearance={Object.values(diagnostic).every(r => r.ok) ? 'success' : 'warning'}
                        >
                          <Text size="small">
                            {Object.values(diagnostic).every(r => r.ok)
                              ? I18n.t('configs.my_account.diagnostic.full')
                              : I18n.t('configs.my_account.diagnostic.partial')}
                          </Text>
                        </SectionHelper>
                      </Box>
                    }
                  </Box>
              </Card.Content>
            </Card>
          </Cell>
        </Layout>
        <Divider />
        {/* FOMRULAIRE D'ADRESSE */}
        <Layout cols={12}>
          <Cell span={4}>
          <Card>
            <MarketingLayout
              title={I18n.t('configs.address.title')}
              description={I18n.t('configs.address.help_text')}
              size="tiny"
            />
          </Card>
          </Cell>
          <Cell span={8}>
            <Card>
              <Card.Content>
                <Cell>
                  <FormField
                    label={I18n.t('configs.address.company')}
                    required
                  >
                    <Input
                      type="text"
                      status={config.sender_company !== null && config.sender_company.length > 0 ? '' : 'error'}
                      name="sender_company"
                      statusMessage={config.sender_company !== null && config.sender_company.length > 0 ? '' : I18n.t('configs.address.company_error')}
                      tooltipPlacement="top-end"
                      value={config.sender_company}
                      onChange={this.handleChange}
                      maxLength="35"
                      suffix={<Input.Affix>{config.sender_company !== null ? 35 - config.sender_company.length +`/35` : `35/35`}</Input.Affix>}
                    />
                  </FormField>
                  <br/>
                </Cell>
                <Layout>
                  <Cell span={6}>
                    <FormField
                      label={I18n.t('configs.address.lastname')}
                      required
                    >
                      <Input
                        type="text"
                        status={config.sender_lastname !== null && config.sender_lastname.length > 0 ? '' : 'error'}
                        name="sender_lastname"
                        statusMessage={config.sender_lastname !== null && config.sender_lastname.length > 0 ? '' : I18n.t('configs.address.lastname_error')}
                        tooltipPlacement="top-end"
                        value={config.sender_lastname}
                        onChange={this.handleChange}
                        maxLength="35"
                        suffix={<Input.Affix>{config.sender_lastname !== null ? 35 - config.sender_lastname.length +`/35` : `35/35`}</Input.Affix>}
                      />
                    </FormField>
                  </Cell>
                  <Cell span={6}>
                    <FormField
                      label={I18n.t('configs.address.firstname')}
                      required
                    >
                      <Input
                        type="text"
                        status={config.sender_firstname !== null && config.sender_firstname.length > 0 ? '' : 'error'}
                        name="sender_firstname"
                        statusMessage={config.sender_firstname !== null && config.sender_firstname.length > 0 ? '' : I18n.t('configs.address.firstname_error')}
                        tooltipPlacement="top-end"
                        value={config.sender_firstname}
                        onChange={this.handleChange}
                        maxLength="35"
                        suffix={<Input.Affix>{config.sender_firstname !== null ? 35 - config.sender_firstname.length +`/35` : `35/35`}</Input.Affix>}
                      />
                    </FormField>
                  </Cell>
                </Layout>
                <br/>
                <Cell>
                  <FormField
                    label={I18n.t('configs.address.address1')}
                    required
                  >
                    <Input
                      type="text"
                      status={config.sender_address1 !== null && config.sender_address1.length > 0 ? '' : 'error'}
                      name="sender_address1"
                      statusMessage={config.sender_address1 !== null && config.sender_address1.length > 0 ? '' : I18n.t('configs.address.address1_error')}
                      tooltipPlacement="top-end"
                      value={config.sender_address1}
                      onChange={this.handleChange}
                      maxLength="35"
                      suffix={<Input.Affix>{config.sender_address1 !== null ? 35 - config.sender_address1.length +`/35`: `35/35`}</Input.Affix>}
                    />
                  </FormField>
                  <br/>
                </Cell>
                <Cell>
                  <FormField
                    label={I18n.t('configs.address.address2')}
                  >
                    <Input
                      type="text"
                      name="sender_address2"
                      tooltipPlacement="top-end"
                      value={config.sender_address2}
                      onChange={this.handleChange}
                      maxLength="35"
                      suffix={<Input.Affix>{config.sender_address2 !== null ? 35 - config.sender_address2.length +`/35` : `35/35`}</Input.Affix>}
                    />
                  </FormField>
                  <br/>
                </Cell>
                <Cell>
                  <FormField
                    label={I18n.t('configs.address.address3')}
                  >
                    <Input
                      type="text"
                      name="sender_address3"
                      tooltipPlacement="top-end"
                      value={config.sender_address3}
                      onChange={this.handleChange}
                      maxLength="35"
                      suffix={<Input.Affix>{config.sender_address3 !== null ? 35 - config.sender_address3.length +`/35` : `35/35`}</Input.Affix>}
                    />
                  </FormField>
                  <br/>
                </Cell>
                <Cell>
                  <FormField
                    label={I18n.t('configs.address.address4')}
                  >
                    <Input
                      type="text"
                      name="sender_address4"
                      tooltipPlacement="top-end"
                      value={config.sender_address4}
                      onChange={this.handleChange}
                      maxLength="35"
                      suffix={<Input.Affix>{config.sender_address4 !== null ? 35 - config.sender_address4.length +`/35` : `35/35`}</Input.Affix>}
                    />
                  </FormField>
                  <br/>
                </Cell>
                <Layout>
                  <Cell span={6}>
                    <FormField
                      label={I18n.t('configs.address.postcode')}
                      required
                    >
                      <Input
                        type="number"
                        status={config.sender_postcode !== null && config.sender_postcode.length > 0 && config.sender_postcode.length == 5 ? '' : 'error'}
                        name="sender_postcode"
                        statusMessage={config.sender_postcode !== null && config.sender_postcode.length > 0 && config.sender_postcode.length == 5 ? '' : I18n.t('configs.address.postcode_error')}
                        tooltipPlacement="top-end"
                        value={config.sender_postcode}
                        onChange={this.handleChange}
                        maxLength={5}
                        suffix={<Input.Affix>{config.sender_postcode !== null ? 5 - config.sender_postcode.length +`/5` : `5/5`}</Input.Affix>}
                      />
                    </FormField>
                  </Cell>
                  <Cell span={6}>
                    <FormField
                      label={I18n.t('configs.address.city')}
                      required
                    >
                      <Input
                        type="text"
                        status={config.sender_city !== null && config.sender_city.length > 0 ? '' : 'error'}
                        name="sender_city"
                        statusMessage={config.sender_city !== null && config.sender_city.length > 0 ? '' : I18n.t('configs.address.city_error')}
                        tooltipPlacement="top-end"
                        value={config.sender_city}
                        onChange={this.handleChange}
                        maxLength="35"
                        suffix={<Input.Affix>{config.sender_city !== null ? 35 - config.sender_city.length +`/35` : `35/35`}</Input.Affix>}
                      />
                    </FormField>
                  </Cell>
                </Layout>
                <br/>
                <Cell>
                  <FormField
                    label={I18n.t('configs.address.country')}
                    required
                  >
                    <Dropdown
                      name="sender_iso_country"
                      options={[
                          {value: "France", id: "FR"},
                          {value: "Guadeloupe", id: "GP"},
                          {value: "Guyane", id: "GF"},
                          {value: "Ile de la Réunion", id: "RE"},
                          {value: "Martinique", id: "MQ"},
                          {value: "Mayotte", id: "YT"},
                          {value: "Saint Barthélémie", id: "BL"},
                          {value: "Saint Martin", id: "MF"},
                          {value: "Saint Pierre et Miquelon", id: "PM"},
                      ]}
                      onSelect={this.handleSelectChangeCountry}
                      selectedId={config.sender_iso_country !== null && config.sender_iso_country ? config.sender_iso_country : 'FR'}
                    />
                  </FormField>
                  <br/>
                </Cell>
                <Layout>
                  <Cell span={6}>
                    <FormField
                      label={I18n.t('configs.address.phone')}
                      required
                    >
                      <Input
                        type="text"
                        status={config.sender_phone !== null && config.sender_phone.length > 0 ? '' : 'error'}
                        name="sender_phone"
                        statusMessage={config.sender_phone !== null && config.sender_phone.length > 0 ? '' : I18n.t('configs.address.phone_error')}
                        tooltipPlacement="top-end"
                        value={config.sender_phone}
                        onChange={this.handleChange}
                      />
                      <Text size="tiny">{I18n.t('configs.address.phone_help')}</Text>
                    </FormField>
                  </Cell>
                  <Cell span={6}>
                    <FormField
                      label={I18n.t('configs.address.mail')}
                      required
                    >
                      <Input
                        type="email"
                        status={config.sender_email !== null && config.sender_email.length > 0 ? '' : 'error'}
                        name="sender_email"
                        statusMessage={config.sender_email !== null &&config.sender_email.length > 0 ? '' : I18n.t('configs.address.mail_error')}
                        tooltipPlacement="top-end"
                        value={config.sender_email}
                        onChange={this.handleChange}
                        maxLength="80"
                        suffix={<Input.Affix>{config.sender_email !== null ? 80 - config.sender_email.length +`/80` : `80/80`}</Input.Affix>}
                      />
                    </FormField>
                  </Cell>
                </Layout>
                <br/>
              </Card.Content>
            </Card>
          </Cell>
        </Layout>
        <Divider />
        {/* FOMRULAIRE D'ADRESSE DE RETOUR */}
        <Layout cols={12}>
          <Cell span={4}>
          <Card>
            <MarketingLayout
              title={I18n.t('configs.address.title_return')}
              description={I18n.t('configs.address.help_text_return')}
              size="tiny"
            />
          </Card>
          </Cell>
          <Cell span={8}>
            <Card>
              <Card.Content>
                <Cell>
                  <div
                    style={{
                      display: 'flex',
                      marginBottom: '15px',
                      alignItems: 'center',
                    }}
                  >
                    <Box verticalAlign="middle">
                      <ToggleSwitch
                        checked={selectedSameAddress}
                        onChange={() => this.setState({ selectedSameAddress: !selectedSameAddress })}
                        size={'small'}
                      />
                      <Box paddingLeft="SP2"><Text>{I18n.t('configs.address.label_same_address_return_sender')}</Text></Box>
                    </Box>
                  </div>
                </Cell>
                <br/>
                <Collapse open={!selectedSameAddress}>
                  <Cell>
                    <FormField
                      label={I18n.t('configs.address.company')}
                      required
                    >
                      <Input
                        type="text"
                        status={config.return_company !== null && config.return_company.length > 0 ? '' : 'error'}
                        name="return_company"
                        statusMessage={config.return_company !== null && config.return_company.length > 0 ? '' : I18n.t('configs.address.company_error')}
                        tooltipPlacement="top-end"
                        value={config.return_company}
                        onChange={this.handleChange}
                        maxLength="35"
                        suffix={<Input.Affix>{config.return_company !== null ? 35 - config.return_company.length +`/35` : `35/35`}</Input.Affix>}
                      />
                    </FormField>
                    <br/>
                  </Cell>
                  <Layout>
                    <Cell span={6}>
                      <FormField
                        label={I18n.t('configs.address.lastname')}
                        required
                      >
                        <Input
                          type="text"
                          status={config.return_lastname !== null && config.return_lastname.length > 0 ? '' : 'error'}
                          name="return_lastname"
                          statusMessage={config.return_lastname !== null && config.return_lastname.length > 0 ? '' : I18n.t('configs.address.lastname_error')}
                          tooltipPlacement="top-end"
                          value={config.return_lastname}
                          onChange={this.handleChange}
                          maxLength="35"
                          suffix={<Input.Affix>{config.return_lastname !== null ? 35 - config.return_lastname.length +`/35` : `35/35`}</Input.Affix>}
                        />
                      </FormField>
                    </Cell>
                    <Cell span={6}>
                      <FormField
                        label={I18n.t('configs.address.firstname')}
                        required
                      >
                        <Input
                          type="text"
                          status={config.return_firstname !== null && config.return_firstname.length > 0 ? '' : 'error'}
                          name="return_firstname"
                          statusMessage={config.return_firstname !== null && config.return_firstname.length > 0 ? '' : I18n.t('configs.address.firstname_error')}
                          tooltipPlacement="top-end"
                          value={config.return_firstname}
                          onChange={this.handleChange}
                          maxLength="35"
                          suffix={<Input.Affix>{config.return_firstname !== null ? 35 - config.return_firstname.length +`/35` : `35/35`}</Input.Affix>}
                        />
                      </FormField>
                    </Cell>
                  </Layout>
                  <br/>
                  <Cell>
                    <FormField
                      label={I18n.t('configs.address.address1')}
                      required
                    >
                      <Input
                        type="text"
                        status={config.return_address1 !== null && config.return_address1.length > 0 ? '' : 'error'}
                        name="return_address1"
                        statusMessage={config.return_address1 !== null && config.return_address1.length > 0 ? '' : I18n.t('configs.address.address1_error')}
                        tooltipPlacement="top-end"
                        value={config.return_address1}
                        onChange={this.handleChange}
                        maxLength="35"
                        suffix={<Input.Affix>{config.return_address1 !== null ? 35 - config.return_address1.length +`/35` : `35/35`}</Input.Affix>}
                      />
                    </FormField>
                    <br/>
                  </Cell>
                  <Cell>
                    <FormField
                      label={I18n.t('configs.address.address2')}
                    >
                      <Input
                        type="text"
                        name="return_address2"
                        tooltipPlacement="top-end"
                        value={config.return_address2}
                        onChange={this.handleChange}
                        maxLength="35"
                        suffix={<Input.Affix>{config.return_address2 !== null ? 35 - config.return_address2.length +`/35` : `35/35`}</Input.Affix>}
                      />
                    </FormField>
                    <br/>
                  </Cell>
                  <Cell>
                    <FormField
                      label={I18n.t('configs.address.address3')}
                    >
                      <Input
                        type="text"
                        name="return_address3"
                        tooltipPlacement="top-end"
                        value={config.return_address3}
                        onChange={this.handleChange}
                        maxLength="35"
                        suffix={<Input.Affix>{config.return_address3 !== null ? 35 - config.return_address3.length +`/35` : `35/35`}</Input.Affix>}
                      />
                    </FormField>
                    <br/>
                  </Cell>
                  <Cell>
                    <FormField
                      label={I18n.t('configs.address.address4')}
                    >
                      <Input
                        type="text"
                        name="return_address4"
                        tooltipPlacement="top-end"
                        value={config.return_address4}
                        onChange={this.handleChange}
                        maxLength="35"
                        suffix={<Input.Affix>{config.return_address4 !== null ? 35 - config.return_address4.length +`/35` : `35/35`}</Input.Affix>}
                      />
                    </FormField>
                    <br/>
                  </Cell>
                  <Layout>
                    <Cell span={6}>
                      <FormField
                        label={I18n.t('configs.address.postcode')}
                        required
                      >
                        <Input
                          type="number"
                          status={config.sender_postcode !== null && config.sender_postcode.length > 0 && config.sender_postcode.length == 5 ? '' : 'error'}
                          name="return_postcode"
                          statusMessage={config.sender_postcode !== null && config.sender_postcode.length > 0 && config.sender_postcode.length == 5 ? '' : I18n.t('configs.address.postcode_error')}
                          tooltipPlacement="top-end"
                          value={config.return_postcode}
                          onChange={this.handleChange}
                          maxLength={5}
                          suffix={<Input.Affix>{config.return_postcode !== null ? 5 - config.return_postcode.length +`/5` : `5/5`}</Input.Affix>}
                        />
                      </FormField>
                    </Cell>
                    <Cell span={6}>
                      <FormField
                        label={I18n.t('configs.address.city')}
                        required
                      >
                        <Input
                          type="text"
                          status={config.return_city !== null && config.return_city.length > 0 ? '' : 'error'}
                          name="return_city"
                          statusMessage={config.return_city !== null && config.return_city.length > 0 ? '' : I18n.t('configs.address.city_error')}
                          tooltipPlacement="top-end"
                          value={config.return_city}
                          onChange={this.handleChange}
                          maxLength="35"
                          suffix={<Input.Affix>{config.return_city !== null ? 35 - config.return_city.length +`/35` : `35/35`}</Input.Affix>}
                        />
                      </FormField>
                    </Cell>
                  </Layout>
                  <br/>
                  <Cell>
                    <FormField
                      label={I18n.t('configs.address.country')}
                      required
                    >
                      <Dropdown
                        name="return_iso_country"
                        options={[
                            {value: "France", id: "FR"},
                            {value: "Guadeloupe", id: "GP"},
                            {value: "Guyane", id: "GF"},
                            {value: "Ile de la Réunion", id: "RE"},
                            {value: "Martinique", id: "MQ"},
                            {value: "Mayotte", id: "YT"},
                            {value: "Saint Barthélémie", id: "BL"},
                            {value: "Saint Martin", id: "MF"},
                            {value: "Saint Pierre et Miquelon", id: "PM"},
                        ]}
                        onSelect={this.handleSelectChangeReturnCountry}
                        selectedId={config.return_iso_country !== null && config.return_iso_country ? config.return_iso_country : 'FR'}
                      />
                    </FormField>
                    <br/>
                  </Cell>
                  <Layout>
                    <Cell span={6}>
                      <FormField
                        label={I18n.t('configs.address.phone')}
                        required
                      >
                        <Input
                          type="text"
                          status={config.return_phone !== null && config.return_phone.length > 0 ? '' : 'error'}
                          name="return_phone"
                          statusMessage={config.return_phone !== null && config.return_phone.length > 0 ? '' : I18n.t('configs.address.phone_error')}
                          tooltipPlacement="top-end"
                          value={config.return_phone}
                          onChange={this.handleChange}
                        />
                        <Text size="tiny">{I18n.t('configs.address.phone_help')}</Text>
                      </FormField>
                    </Cell>
                    <Cell span={6}>
                      <FormField
                        label={I18n.t('configs.address.mail')}
                        required
                      >
                        <Input
                          type="email"
                          status={config.return_email !== null && config.return_email.length > 0 ? '' : 'error'}
                          name="return_email"
                          statusMessage={config.return_email !== null && config.return_email.length > 0 ? '' : I18n.t('configs.address.mail_error')}
                          tooltipPlacement="top-end"
                          value={config.return_email}
                          onChange={this.handleChange}
                          maxLength="80"
                          suffix={<Input.Affix>{config.return_email !== null ? 80 - config.return_email.length +`/80` : `80/80`}</Input.Affix>}
                        />
                      </FormField>
                    </Cell>
                  </Layout>
                  <br/>
                </Collapse>
              </Card.Content>
            </Card>
          </Cell>
        </Layout>
      </div>
    );
  }
}

export default MyAccount
